module.exports = __webpack_public_path__ + "static/contact-9387f9da5734c72a9d8d4e58692f643d.jpg";